import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypeById, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";
import parse from "html-react-parser";

import icon_mail from "../images/icons/payments/mail.svg"
import icon_printer from "../images/icons/payments/printer.svg"
import icon_paypal from "../images/icons/payments/paypal.svg"
import icon_mastercard from "../images/icons/payments/mastercard.svg"
import icon_visa from "../images/icons/payments/visa.svg"
import icon_amex from "../images/icons/payments/amex.svg"
import icon_twint from "../images/icons/payments/twint.svg"
import icon_postfinance from "../images/icons/payments/postfinance.svg"
import icon_invoice from "../images/icons/payments/invoice.svg"


import Header from "./components/Header";

const Checkout = () => {
    const [orderId] = useState(sessionStorage.getItem("orderId"));
    const [token] = useState(sessionStorage.getItem("token"));

    const [eventIdWorkshopsSpecials, setEventIdWorkshopsSpecials] = useState();
    const [eventIdWorkshopsMasterclass, setEventIdWorkshopsMasterclass] = useState();

    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);
    const [payment, setPayment] = useState({
        paymentMethodId: 0,
        deliveryMethodId: 0,
        insurance: false
    })

    const [orderInsurancePrice, setOrderInsurancePrice] = useState(0);

    const [onlyInvoiceTickets, setOnlyInvoiceTickets] = useState(false);

    const [countSaturdayTickets] = useState(sessionStorage.getItem("countSaturdayTickets"));
    const [countSundayTickets] = useState(sessionStorage.getItem("countSundayTickets"));

    const [isAgbChecked, setIsAgbChecked] = useState(false);

    const [submitError, setSubmitError] = useState("");

    const [promotioncode, setPromotioncode] = useState("");
    const [addedPromotionCodes, setAddedPromotionCodes] = useState([]);
    const [promotionError, setPromotionError] = useState({
        text: "",
        valid: false
    });

    const [totalSelectedWorkshopsSaturday, setTotalSelectedWorkshopsSaturday] = useState(0);
    const [totalSelectedWorkshopsSunday, setTotalSelectedWorkshopsSunday] = useState(0);

    const isButtonFinishOrderDisabled = payment.paymentMethodId === 0 || payment.deliveryMethodId === 0 || !isAgbChecked;

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [resourcesTranslation, setResourcesTranslation] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // gtm - addPaymentInfo
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'addPaymentInfo'
        });
    }, [])

    useEffect(() => {
        if (!tickets || !eventIdWorkshopsSpecials || !eventIdWorkshopsMasterclass) return;
        setTotalSelectedWorkshopsSaturday(tickets.filter(t => t.ticketType?.eventId === eventIdWorkshopsSpecials).length);
        setTotalSelectedWorkshopsSunday(tickets.filter(t => t.ticketType?.eventId === eventIdWorkshopsMasterclass).length);
    }, [tickets, eventIdWorkshopsSpecials, eventIdWorkshopsMasterclass])

    useEffect(() => {
        requestResources();
        requestFormSettings();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadOrder(orderId);
            getOrderInsurance();
        }
    }, [orderId]); //gets called when an order is started

    // Add promocodes to page if already existing in order
    useEffect(() => {
        if (order && Array.isArray(order.tickets)) {
            const codes = [];
            order.tickets.forEach(ticket => {
                if (ticket.promotionCode && !codes.includes(ticket.promotionCode)) {
                    codes.push(ticket.promotionCode);
                }
            });
            // Only update state if codes are different
            if (codes.length > 0 && (codes.length !== addedPromotionCodes.length || !codes.every(c => addedPromotionCodes.includes(c)))) {
                setAddedPromotionCodes(codes);
            }
        }
    }, [order]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.checkOut);
                setResourcesTranslation(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const requestFormSettings = async () => {
        try {
            const res = await axios.get(`form/formsettings`);
            setEventIdWorkshopsSpecials(res.data.eventIdWorkshopsSpecials)
            setEventIdWorkshopsMasterclass(res.data.eventIdWorkshopsMasterclass)
        } catch (error) {
            console.error(error);
        }
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            let updatedPayment = { ...payment, deliveryMethodId: updatedOrder.deliveryMethodId, paymentMethodId: updatedOrder.paymentMethodId };

            updatedPayment.insurance = updatedOrder.totalInsuranceAmount > 0;

            setPayment(updatedPayment);
            setOrder(updatedOrder);
            setTickets(updatedTickets);

            const allInvoiceTickets = updatedTickets.every(t => t.ticketTypeId === 819445);
            setOnlyInvoiceTickets(allInvoiceTickets);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const onAgbChange = (isAgbChecked) => {
        setIsAgbChecked(isAgbChecked);
    };

    const changeDeliveryType = async (deliveryMethodId) => {
        await axios.put(
            `${baseUrl}/ShopBasket/Order/${orderId}/DeliveryMethod/${deliveryMethodId}`)
            .then(() => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const changePaymentType = (paymentMethodId) => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/${paymentMethodId}`)
            .then((res) => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const addPromotionToOrder = async () => {
        try {
            await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotioncode}`);

            setPromotionError({
                text: `${resources.PromocodeSuccess} (${promotioncode})`,
                valid: true
            });

            setAddedPromotionCodes((current) => [...current, promotioncode]);

            await loadOrder(orderId);
            setPromotioncode("");
        } catch (error) {
            setPromotionError({
                text: resources.PromocodeError,
                valid: false
            });
        }
    };

    const startDatatrans = () => {

        let domain = "https://" + window.location.host;

        const redirectUrl = `${domain}/form/redirect/${language}/${orderId}`;
        const errorUrl = `${domain}/form/error/${language}/${orderId}`;
        const cancelUrl = `${domain}/form/cancel/${language}/${orderId}`;

        var baseRequestUrl = `https://datatrans.ticketino.com/Datatrans/${orderId}/DigitalSignature?redirectUrl=${redirectUrl}&errorUrl=${errorUrl}&cancelUrl=${cancelUrl}`;

        axios
            .get(baseRequestUrl)
            .then((res) => {

                var url = res.data.datatransPaymentRedirectUrl.replace("{0}", res.data.transactionId);

                window.location.href = url;
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onBackClick = async () => {
        navigate(-1)
    }

    const validateOrderStillExists = async () => {
        try {
            const latest = await getOrderByOrderId(orderId);
            if (!latest) return false;
            if (!latest?.id) return false;
            if (!Array.isArray(latest?.tickets) || latest.tickets.length === 0) return false;
            return true;
        } catch (e) {
            return false;
        }
    }

    const onSubmit = async () => {

        setSubmitError("");

        const exists = await validateOrderStillExists();
        if (!exists) {
            setSubmitError(resources?.OrderExpiredMessage || "Your reservation is no longer available. Please start again.");
            return;
        }

        if (order?.totalPrice > 0) {
            let dataTransProviders = [1, 7, 8, 9, 10, 14];

            let datatransProvider = dataTransProviders.findIndex((d) => d === payment.paymentMethodId) !== -1

            if (datatransProvider) {
                startDatatrans();
            } else {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            }
        } else {
            changePaymentTypeToFree();
        }
    }

    const getOrderInsurance = async () => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`);
            setOrderInsurancePrice(res.data);
        } catch (error) {
            console.error(error);
        }
    }

    const setOrderInsurance = async () => {
        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    const removeOrderInsurance = async () => {
        await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            return res.data;
        } catch (error) {
            console.error(error)
        }
    };

    const changePaymentTypeToFree = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(async () => {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    }

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => {
                // Check if this is a workshop ticket (EventId 214329 or 214330)
                const isWorkshopTicket = tt.ticketType?.eventId === eventIdWorkshopsSpecials || tt.ticketType?.eventId === eventIdWorkshopsMasterclass;
                const displayPrice = isWorkshopTicket ? tt.price + 15.00 : tt.price;
                
                return (
                    <div key={tt.id}>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="d-flex align-items-center flex-nowrap">
                                <label className="ticket-name-label mb-0">
                                    1x {tt.info?.name}
                                </label>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                <label className="text-nowrap mb-0">
                                    {tt.ticketType?.currency} {displayPrice.toFixed(2)}
                                </label>
                            </div>
                        </div>
                    </div>
                );
            })
        );
    };

    const mapPromotionCodes = () => {
        if (!addedPromotionCodes || addedPromotionCodes.length === 0) {
            return null;
        }

        return (
            <div className="row pt-2 pb-1">
                <div className="col-md-8 col-8">
                    <label>{resources.PromotionCodes || "Promotion Codes"}</label>
                </div>
                <div className="col-md-4 col-4 text-end">
                    <label>{addedPromotionCodes.join(", ")}</label>
                </div>
            </div>
        );
    };

    const mapExtraCosts = () => {
        return (
            <div>
                <div className="row pt-2 pb-1">
                    <div className="col-md-8 col-8">
                        <label>{resources.DeliveryCosts}</label>
                    </div>
                    <div className="col-md-4 col-4 text-end">
                        <label>{order.currency + " " + order?.deliverPaymentFee.toFixed(2)}</label>
                    </div>
                </div>
            </div>
        )
    }

    const mapInsurance = () => {
        return (
            <div>
                <div className="row pt-2">
                    <div className="col-md-10 col-8">
                        <label>{resources.TicketInsurance}</label>
                    </div>
                    <div className="col-md-2 col-4 text-end">
                        <label>
                            {order.currency + " " + order.totalInsuranceAmount.toFixed(2)}
                        </label>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div id="datatrans-form-placeholder"></div>

            <Header language={language} pagePath="checkout" />

            <div className="page-container">



                <div className="container wrapper">
                    {/*<div className="row mt-4">*/}
                    {/*    <div className="col-md-12 mb-1">*/}
                    {/*        <p>{resources.DeliveryOption}</p>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div className="mb-4">*/}
                    {/*    <div className="form-check mb-3">*/}
                    {/*        <input*/}
                    {/*            className="form-check-input me-2"*/}
                    {/*            type="radio"*/}
                    {/*            name="flexRadioDefault1"*/}
                    {/*            checked={payment.deliveryMethodId === 1 ? true : false}*/}
                    {/*            onClick={() => changeDeliveryType(1)}*/}
                    {/*            id="printAtHome"*/}
                    {/*        />*/}
                    {/*        <label*/}
                    {/*            className="d-inline"*/}
                    {/*            htmlFor="printAtHome"*/}
                    {/*        >*/}
                    {/*            <img htmlFor="mail" src={icon_mail} className="delivery_icon" alt="Mail Icon" />*/}
                    {/*            {resources.PrintAtHome}*/}
                    {/*            <p className="m-0 text-secondary delivery-description">*/}
                    {/*                {resources.PrintAtHomeDescription}*/}
                    {/*            </p>*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {
                        order.totalPrice > 0 &&
                        <>
                            {/* intro */}
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="text-title">{resources?.HomeTitle}</h1>
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-md-12 mb-1">
                                    <p>{resources.PaymentOption}</p>
                                </div>
                            </div>
                            <div className="mb-5">
                                {[
                                    { id: "mastercard", paymentMethodId: 1, icon: icon_mastercard, name: resources.MasterCard, description: resources.MasterCardDesc },
                                    { id: "visa", paymentMethodId: 7, icon: icon_visa, name: resources.Visa, description: resources.VisaDesc },
                                    { id: "amex", paymentMethodId: 8, icon: icon_amex, name: resources.AmericanExpress, description: resources.AmericanExpressDesc },
                                    { id: "postfinance", paymentMethodId: 9, icon: icon_postfinance, name: resources.PostFinance, description: resources.PostFinanceDesc },
                                    { id: "paypal", paymentMethodId: 10, icon: icon_paypal, name: resources.PayPal, description: resources.PayPalDesc },
                                    { id: "twint", paymentMethodId: 14, icon: icon_twint, name: resources.Twint, description: resources.TwintDesc },
                                    // invoice stays in the last position
                                    /*{ id: "invoice", paymentMethodId: 2, icon: icon_invoice, name: resources.PaymmentInvoice, description: resources.PaymentSmallFee },*/
                                ].map((paymentMethod) => (
                                    <div className="d-flex align-items-center mb-4" key={paymentMethod.id}>
                                        <input
                                            className="form-check-input flex-shrink-0 mt-0"
                                            type="radio"
                                            name="flexRadioDefault"
                                            checked={payment.paymentMethodId === paymentMethod.paymentMethodId}
                                            onChange={() => changePaymentType(paymentMethod.paymentMethodId)}
                                            id={paymentMethod.id}
                                        />
                                        <label
                                            className="payment-names d-flex align-items-center cursor-pointer mb-0"
                                            htmlFor={paymentMethod.id}
                                        >
                                            <img src={paymentMethod.icon} className="payment_icon" alt={`${paymentMethod.name} Icon`} />
                                            <span>
                                                {paymentMethod.name}
                                                {paymentMethod.description &&
                                                    <span className="payment-description d-block text-secondary">
                                                        {paymentMethod.description}
                                                    </span>
                                                }
                                            </span>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </>
                    }

                    {order.totalPrice > 0 &&
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <p className="mb-2 text-uppercase">{resources?.TicketInsurance}</p>
                                <div className="form-check mb-4">
                                    <input
                                        className="form-check-input me-3 "
                                        type="checkbox"
                                        checked={payment.insurance}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setOrderInsurance();
                                            } else {
                                                removeOrderInsurance();
                                            }
                                        }}
                                    />
                                    <label className="col-11 form-check-label fs-6" htmlFor="inlineCheckbox1">
                                        {parse(
                                            (orderInsurancePrice === 0
                                                ? resources.TicketInsuranceDescGeneric
                                                : (resources.TicketInsuranceDesc ?? "").replace("{@InsurancePrice}", orderInsurancePrice.toFixed(2))
                                            ) ?? ""
                                        )}
                                    </label>
                                </div>

                            </div>
                        </div>}

                    <div className="row">
                        <div className="col-md-12">
                            <p className="mb-1 text-uppercase">{resources.Summary}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <>
                                {mapTickets()}

                                <hr className="ticket-separator" />

                                {addedPromotionCodes.length > 0 && mapPromotionCodes()}
                                {payment.insurance && mapInsurance()}
                                {order.deliverPaymentFee > 0 && mapExtraCosts()}
                                <div className="row mt-1 mb-3">
                                    <div className="col-md-8 col-8">
                                        <span>
                                            {resources.Total}
                                        </span>
                                    </div>
                                    <div className="col-md-4 col-4 text-end">
                                        <span>
                                            {order.currency} {order.totalPrice?.toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>

                    {/* AGB */}
                    <div className="row mt-5">
                        <div className="col-md-12 d-flex align-items-start">
                            <input
                                type="checkbox"
                                id="agb"
                                className="form-check-input mt-0 me-3 flex-shrink-0"
                                checked={isAgbChecked}
                                onChange={(e) => onAgbChange(e.target.checked)}
                            />
                            <label className="cursor-pointer mb-0" style={{ marginTop: "-2px" }} htmlFor="agb" dangerouslySetInnerHTML={{ __html: resources?.AGB }}></label>
                        </div>
                    </div>


                    {/* Buttons */}
                    <div className="row mt-5">
                        <div className="col-6">
                            <button className="btn btn-custom" onClick={() => navigate(-1)}>{resources?.Back}</button>
                        </div>
                        <div className="col-6 text-end">
                            <button className="btn btn-custom" disabled={isButtonFinishOrderDisabled} onClick={() => onSubmit()}>{order.totalPrice > 0 ? resources?.Buy : resources?.BuyFree}</button>
                        </div>
                    </div>

                    {submitError && (
                        <div className="row mt-3">
                            <div className="col-12">
                                <div className="alert alert-danger" role="alert">
                                    {submitError}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small className="powered-by">powered by <a href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Checkout